import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useMutation } from "@tanstack/react-query";
import { ObjectiveSystemsValidationSchema } from "../schemas/objectiveSystems.schema";

interface UseUpdateObjectiveSystemProps {
  id?: string;
  onSuccess?: () => void
  onError?: (error: any) => void
}

const useUpdateObjectiveSystem = ({ id, onSuccess, onError }: UseUpdateObjectiveSystemProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['updateMaintenanceObjectiveSystem', id],
    mutationFn: (data: ObjectiveSystemsValidationSchema) => {
      const payload = {
        objective_system: {
          display_name: data.display_name,
        }
      }

      return privateAxios.put(`/maintenance/objective_systems/${id}`, payload);
    },
    onSuccess,
    onError,
  });
}

export default useUpdateObjectiveSystem;
